import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { QualificationForm } from './components/QualificationForm';
import { Reviews } from './components/Reviews';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-black font-sans selection:bg-amber-400/30 selection:text-white" data-id="element-0" data-mp="3fb16pjn7u9cf">
      <Navbar data-id="element-1" data-mp="2rlf6qtz0rq3d" />
      <main data-id="element-2" data-mp="2rit14zvovkns">
        {/* 1. VSL */}
        <Hero data-id="element-3" data-mp="2mm2j470bqezq" />
        {/* 2. Formulario de cualificación */}
        <QualificationForm data-id="element-4" data-mp="2mjpw3ffpleft" />
        {/* 3. Testimonios */}
        <Reviews data-id="element-5" data-mp="31bs11dwmyxmp" />
      </main>
      <Footer data-id="element-6" data-mp="31c1igd3m7wgs" />
      <StickyCTA data-id="element-7" data-mp="31cjo20c63n1d" />
    </div>;
}